import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { AppSettings } from "components/AppSettings";
import { DeviceAlarmCTX } from "functions/Context";
import { ReloadButton, useLoader } from "functions/networking/useLoader"
import { warning } from "ionicons/icons";
import { RouterMap } from "navigation/RouterMap";
import { FC, PropsWithChildren, ReactNode, useContext, useEffect } from "react";


export const Page : FC<PropsWithChildren<{
  title : ReactNode,
  hideBackButton? : boolean,
  additionalButtons? : ReactNode,
  loaders? : ReturnType<typeof useLoader>[],
  ignoreAlarms ?: boolean,
}>> = (props) => {
  const alarms = useContext(DeviceAlarmCTX);

  useEffect(function HideAlarmsWhenIgnored() {
    if (props.ignoreAlarms) alarms?.setShowAlarm(false);
  }, [props.ignoreAlarms, alarms?.showAlarm]);

  return <IonPage>
    <IonHeader>
      <IonToolbar color="tertiary">
        {props.hideBackButton
        ? <></>
        : <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>}
        <IonTitle>{props.title}</IonTitle>
        <IonButtons slot="end">
          {alarms?.showAlarm && !props.ignoreAlarms &&
            <IonButton routerLink={RouterMap.alarms} onClick={() => alarms?.setShowAlarm(false)}>
              <IonIcon icon={warning} color="warning" className="blinking" />
            </IonButton>
          }
          {props.additionalButtons ?? <></>}
          {props.loaders ? <ReloadButton loaders={props.loaders } /> : ""}
          <AppSettings />
        </IonButtons>
      </IonToolbar>
    </IonHeader>

    <IonContent>
      {props.children}
    </IonContent>
  </IonPage>
}

